exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/components/atado-info/atado-info.component.css
// module id = ../../../../../src/app/components/atado-info/atado-info.component.css
// module chunks = main